<template>
  <div class="main-body" :style='"height:"+(th+115)+"px"'>
<!--    <div class="header">科室奖金二次分配</div>-->
    <div class="out">

      <div class="search2">

        <div style="float:right;">

          <el-select v-model="dateStr" clearable placeholder="请选择时间点" style="margin-right: 5px;">
            <el-option
                v-for="item in dateList"
                :key="item.dateStr"
                :label="item.dateStr"
                :value="item.dateStr">
            </el-option>
          </el-select>

          <el-button size="mini" type="primary" plain icon="el-icon-search" @click="getList">搜索</el-button>
        </div>
        <div style="clear: both;"></div>
      </div>


      <el-table class="table" size="mini" v-loading="loading" :data="tableData" :height="th" border>
        <el-table-column prop="departmentClassName" label="科室分类" width="100"></el-table-column>
        <el-table-column prop="departmentName" label="科室" width="100"></el-table-column>
        <el-table-column prop="dateStr" label="时间点" width="100"></el-table-column>

        <el-table-column prop="dateStr" label="奖金二次分配" min-width="300">
          <template slot-scope="scope">
            <div v-for="(item) in scope.row.listDepartmentGainTwo" :key="item.id">

              <div v-if="item.merits>=0">
                奖励:{{item.merits}},说明:{{item.remarks}}

                <el-button size="mini" type="text" @click="handleDelete(scope.$index, item)">x</el-button>

              </div>
              <div v-if="item.merits<0">
                惩罚:{{item.merits}},说明:{{item.remarks}}

                <el-button size="mini" type="text" @click="handleDelete(scope.$index, item)">x</el-button>
              </div>

            </div>
          </template>
        </el-table-column>


        <el-table-column fixed="right" label="操作" width="100">
          <template slot-scope="scope">

            <el-button size="mini" type="text" @click="handleAdd(scope.$index, scope.row)">添加</el-button>

<!--            <el-button size="mini" type="danger" plain @click="handleDelete(scope.$index, scope.row)">删除</el-button>-->
          </template>
        </el-table-column>

      </el-table>
      <div class="page">
        <div style="float: left;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
        <div style="float: left;">
          <el-pagination small
                         background
                         layout="prev, pager, next"
                         :total="totalItems"
                         :page-size="20"
                         :current-page.sync="currentPage"  @current-change="current_change">
          </el-pagination>
        </div>
        <div style="clear: both;"></div>
      </div>


    </div>

    <Add ref="myAdd" v-show="showModalAdd" v-on:closeMe="showModalAdd=false" v-on:getList="getList"></Add>


  </div>
</template>

<script>

import Add from "./Add";

import {getStaffCode,getGovernmentCode} from "@/utils/auth";
import {timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";

export default {
  name: "Page",
  activated() {

    let topTabs = this.$store.state.topTabs;
    if(topTabs && topTabs.length>0){
      let path = this.$route.path;
      let index = topTabs.findIndex(item => item === path);
      if(index ==-1){
        this.init();
      }
    }
    else{
      this.init();
    }


    let topTabs1 = this.$store.state.topTabs;
    if(topTabs1 == null){
      topTabs1 = [];
      topTabs1.push(this.$route.path);
      this.$store.commit('update', ['topTabs',topTabs1]);
    }
    else{
      let index = topTabs.findIndex(item => item === this.$route.path);
      if(index ==-1){
        topTabs1.push(this.$route.path);
        this.$store.commit('update', ['topTabs',topTabs1]);
      }
    }


  },
  deactivated() {
    //console.log("JobClass停用");
  },

  data(){
    return{

      loading:false,

      departmentId:'',
      dateStr:'',

      tableData:[],
      totalItems: 0,
      pageSize:20,
      currentPage:1,

      showModalAdd:false,

      th:0,

      departmentList:[],
      dateList:[],

    }
  },
  created(){
    this.th = this.$store.state.tableHeight;
  },
  components:{
    Add
  },
  watch: {
    //监听全局变量
    '$store.state.tableHeight' : function(val){
      this.th = val;
    },
  },
  methods:{

    init(){
      this.getDateList();
      this.getList();
    },

    getDateList(){
      this.$axios({
        method: 'post',
        url: this.$shopUrl+'DepartmentInOutData/GovListDate',
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          governmentCode:getGovernmentCode(),
        }
      }).then( (response)=> {
        //console.log(response);
        if(response.data.error == 0){
          this.dateList = response.data.data.list;
        }else if(response.data.error == 1){
          this.$message(response.data.message);
        }else{
          console.log(response.data.message);
        }

      }).catch(function (error) {
        console.log(error);
      });
    },

    handleAdd(index, row) {
      this.$refs.myAdd.init(row);
      this.showModalAdd = !this.showModalAdd;
    },



    search(){
      this.currentPage = 1;
      this.getList();
    },
    current_change:function(currentPage){
      this.currentPage = currentPage;
      this.getList();
    },
    getList(){
      this.loading = true;
      this.$axios({
        method: 'post',
        url: this.$shopUrl+'DepartmentGain/GovPageTwo',
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          governmentCode:getGovernmentCode(),
          pageIndex: this.currentPage,
          pageSize: this.pageSize,
          dateStr:this.dateStr,
          departmentId:'',
        }
      }).then( (response)=> {
        //console.log(response);
        this.loading = false;
        if(response.data.error == 0){
          this.tableData = response.data.data.pageInfo.list;
          this.totalItems = response.data.data.pageInfo.total;
        }else if(response.data.error == 1){
          this.$message(response.data.message);
        }else{
          console.log(response.data.message);
        }

      }).catch(function (error) {
        console.log(error);
      });
    },


    handleDelete(index,row){
      this.$confirm('确定删除此数据?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {

        this.$axios({
          method: 'post',
          url: this.$shopUrl + "DepartmentGain/GovDeleteTwo",
          data: {
            timeStr: timeStr,
            sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
            staffCode: getStaffCode(),
            departmentGainTwoId:row.id,
          }
        }).then((response) => {
          if (response.data.error == 0) {
            this.getList();
            this.$message({type: 'success', message: '删除成功'});
          } else if (response.data.error == 1) {
            this.$message({type: 'error', message: response.data.message});
          }
        }).catch(function (error) {
          console.log(error);
        });

      }).catch(() => {
      });

    },




  }
}
</script>

